 
class Qts {  
    public static campos = () => {
        return [  
            {
                nome: "nome",
                type: "text",
                label: "Nome",
                sm: 12,
                lg: 6, 
                disabled: false
            },   
            {
                nome: "inicio",
                type: "date",
                label: "Data de Início",
                sm: 6 ,
                lg: 3, 
                disabled: false
            },  
            {
                nome: "fim",
                type: "date",
                label: "Data de Término",
                sm: 6 ,
                lg: 3, 
                disabled: false
            },   
 
        ];
    }   
}
  
export   {   Qts };
